

























































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbAlert, mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardImage, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter, mdbCardUp, mdbCardAvatar, mdbView, mdbMask } from '@folky-tools/mdbvue';
import { usersService, referencesClassificationService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { ClassificationSummary } from '@/models/references-classification/classification-summary';

@Component({
    components: {
        mdbAlert,
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardImage,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        mdbCardFooter,
        mdbCardUp,
        mdbCardAvatar,
        mdbView,
        mdbMask,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessReferencesClassificationView extends Vue {
    private classificationSummary: ClassificationSummary = new ClassificationSummary();

    private pageContentLoaded: boolean = false;

    private async created(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessReferencesClassificationView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');

        this.classificationSummary = await referencesClassificationService.getClassificationSummary(+this.$route.params.id);
    }

    private async mounted(): Promise<void> {
        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.ReferencesClassification,
                entityId: +this.$route.params.id
            })
        );
        this.pageContentLoaded = true;
    }
}
